import styled from 'styled-components'

export const UlStyled = styled.ul`
  list-style-type: circle;
`
export const LiStyled = styled.li`
  padding: ${props => props.padding};
  margin: ${props => props.margin};
`
